import React from 'react';
import GlobalCtx from '@components/globalContext';

type Props = {
  className?: string;
  onChange: (low: number, high: number) => void;
};
const Thresholds = ({ className, onChange }: Props): JSX.Element => {
  const { app } = React.useContext(GlobalCtx);
  const { thresholds } = app;

  const onThresholdChange = (changedValue: number, type: string) => {
    const isLow = type === 'low';
    onChange(isLow ? changedValue : thresholds.low, isLow ? thresholds.high : changedValue);
  };

  return (
    <div className={className}>
      <ul>
        <li>
          <label className="text-sm">
            High: <span className="font-bold">{thresholds.high}</span>
          </label>
          <input
            onChange={(e) => {
              onThresholdChange(parseInt(e.target.value, 10), 'high');
            }}
            type="range"
            value={thresholds.high}
            max={300}
            className="w-full h-2 bg-sky-200 rounded-lg appearance-none cursor-pointer dark:bg-sky-700"
          ></input>
        </li>
        <li className="mt-4">
          <label className="text-sm">
            Low: <span className="font-bold">{thresholds.low}</span>
          </label>
          <input
            onChange={(e) => {
              onThresholdChange(parseInt(e.target.value, 10), 'low');
            }}
            type="range"
            value={thresholds.low}
            max={300}
            className="w-full h-2 bg-sky-200 rounded-lg appearance-none cursor-pointer dark:bg-sky-700"
          ></input>
        </li>
      </ul>
    </div>
  );
};

export default Thresholds;
